import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const flagDraftMessage = {
  name: "flagDraftMessage" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    category: createEnum(categories),
  }),
  output: z.object({ success: z.boolean() }),
};
